import {
  FEATURE_SPECIAL_INITIATIVES_MARKET,
  FEATURE_SPECIAL_INITIATIVES_CLIENTS,
  FEATURE_SPECIAL_INITIATIVES_INVESTORS,
  FEATURE_SPECIAL_INITIATIVES_TRENDS,
} from "@/constants";

const routes = [
  {
    path: "/special_initiatives",
    name: "SpecialInitiativesRoot",
    component: () => import("@/views/SpecialInitiatives.vue"),
    redirect: { name: "SpecialInitiativesMarket" },
    children: [
      {
        path: "market",
        component: () => import("@/views/SpecialInitiatives/Market.vue"),
        name: "SpecialInitiativesMarket",
        meta: {
          feature: FEATURE_SPECIAL_INITIATIVES_MARKET,
          specialInitiatives: true,
        },
      },
      {
        path: "clients",
        component: () => import("@/views/SpecialInitiatives/Clients.vue"),
        name: "SpecialInitiativesClients",
        meta: {
          feature: FEATURE_SPECIAL_INITIATIVES_CLIENTS,
          specialInitiatives: true,
        },
      },
      {
        path: "company/:companyId",
        component: () => import("@/views/SpecialInitiatives/Company.vue"),
        name: "SpecialInitiativesCompany",
        meta: {
          feature: FEATURE_SPECIAL_INITIATIVES_CLIENTS,
          specialInitiatives: true,
        },
      },
      {
        path: "brand/:brandId",
        component: () => import("@/views/SpecialInitiatives/Brand.vue"),
        name: "SpecialInitiativesBrand",
        meta: {
          feature: FEATURE_SPECIAL_INITIATIVES_CLIENTS,
          specialInitiatives: true,
        },
      },
      {
        path: "product/:productId",
        component: () => import("@/views/SpecialInitiatives/Product.vue"),
        name: "SpecialInitiativesProduct",
        meta: {
          feature: FEATURE_SPECIAL_INITIATIVES_CLIENTS,
          specialInitiatives: true,
        },
      },
      {
        path: "top_investors",
        component: () => import("@/views/SpecialInitiatives/TopInvestors.vue"),
        name: "SpecialInitiativesTopInvestors",
        meta: {
          feature: FEATURE_SPECIAL_INITIATIVES_INVESTORS,
          specialInitiatives: true,
        },
      },
      {
        path: "trend",
        component: () => import("@/views/SpecialInitiatives/Trend.vue"),
        name: "SpecialInitiativesTrend",
        meta: {
          feature: FEATURE_SPECIAL_INITIATIVES_TRENDS,
          specialInitiatives: true,
        },
      },
    ],
  },
];

export default routes;
